import request from "@/utils/request";
import {AxiosResponse} from "axios";

export async function getCurrentRoomId() {
  return request.get<any, AxiosResponse<any[]>>('/api/room-infos/current-room');
}
export async function getCurrentProjectId() {
  return request.get<any, AxiosResponse<any[]>>('/api/project-infos/current-project');
}

export async function changeProjectId(params?: any) {
  return request.get<any, AxiosResponse<any[]>>('/api/project-infos/change-project', { params: params });
}


export async function getProjectList(params?: any) {
  return request.get<any, AxiosResponse<any[]>>('/api/project-infos', { params: params });
}

export async function getRoomList(params?: any) {
  return request.get<any, AxiosResponse<any[]>>('/api/room-infos', { params: params });
}

export async function getProjectListByPermission() {
  return request.get<any, AxiosResponse<any[]>>('/api/project-infos/list');
}

export async function getProjectInfo(id?: string) {
  return request.get<any, AxiosResponse<any[]>>(`/api/project-infos/${id}`);
}

export async function updateProject(data?: any) {
  return request.put<any, AxiosResponse<any>>('/api/project-infos', data);
}

export async function updateProjectParent(data?: any) {
  return request.put<any, AxiosResponse<any>>('/api/project-infos/update-parent', data);
}


export async function createProject(data?: any) {
  return request.post<any, AxiosResponse<any>>('/api/project-infos', data);
}

export async function deleteProject(id?: string) {
  return request.delete<any, AxiosResponse>(`/api/project-infos/${id}`);
}

export async function updateSubscribe(data?: any) {
  return request.post<any, AxiosResponse<any>>('/api/project-infos/update-project-subscribe', data);
}
export async function getAllSubscribe(params?: any) {
  return request.get<any, AxiosResponse<any>>('/api/project-infos/get-project-subscribe', params);
}
export async function getSubscribeUsers(params?: any) {
  return request.get<any, AxiosResponse<any>>('/api/project-infos/get-subscribe-users', params);
}
export async function deleteSubscribe(params?: any) {
  return request.delete<any, AxiosResponse<any>>('/api/project-infos/delete-subscribe', {params});
}

export async function getProjectQuota(params?: any) {
  return request.get<any, AxiosResponse<any>>('/api/quota/project-create', { params: params });
}

export async function getUserQuota(params?: any) {
  return request.get<any, AxiosResponse<any>>('/api/quota/user-create', { params: params });
}